import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Apla} from "@pg-design/apla-module";
import {Button} from "@pg-design/button-module";
import {Col, Hidden} from "@pg-design/grid-module";
import {mb, p} from "@pg-design/helpers-css-strings";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {RankingMainViewFilterPanel} from "./RankingMainViewFilterPanel";

const headerXl = require("../../images/header_xl.png");
const headerLg = require("../../images/header_lg.png");
const headerMd = require("../../images/header_md.png");
const headerSm = require("../../images/header_sm.png");
const headerXs = require("../../images/header_xs.png");

interface IProps {
    onScrollToRankingCreationSteps: () => void;
}

export const RankingHeader = (props: IProps) => {
    return (
        <>
            <div css={rankingHeader}>
                <Apla
                    css={apla}
                    applyOn={
                        <Picture
                            sources={[
                                {minWidthPX: 0, src: headerXs, height: 512, width: 360},
                                {minWidthPX: 350, src: headerSm, height: 512, width: 600},
                                {minWidthPX: 600, src: headerMd, height: 512, width: 1366},
                                {minWidthPX: 1366, src: headerLg, height: 512, width: 1920},
                                {minWidthPX: 1920, src: headerXl, height: 512, width: 2560}
                            ]}
                            alt="header"
                            fit="top left"
                        />
                    }
                />
                <div css={rankingHeaderContent}>
                    <div>
                        <Text css={headline} color="#fff" fontFamily="secondary" variant="headline_1">
                            {concatWithBrandName("Ranking Inwestycji portalu")}
                        </Text>

                        <Text css={headerMb} color="#fff" variant="body_copy_0">
                            Po raz kolejny przygotowaliśmy zestawienie najpopularniejszych inwestycji w największych miastach w Polsce! Sprawdź, które
                            inwestycje odwiedzano najczęściej i które projekty deweloperskie przyciągnęły największą uwagę mieszkańców, którzy znaleźli
                            wymarzone M dzięki serwisowi {concatWithBrandName("")}!
                        </Text>

                        <StyledButton onClick={props.onScrollToRankingCreationSteps} variant="filled_primary" css={headerMb}>
                            Zobacz, jak powstał ranking
                        </StyledButton>
                    </div>
                    <Hidden on="mobile" css={desktopPanel}>
                        <RankingMainViewFilterPanel />
                    </Hidden>
                </div>
            </div>

            <Hidden on="desktop">
                <Col>
                    <div css={headerFiltersMobile}>
                        <RankingMainViewFilterPanel />
                    </div>
                </Col>
            </Hidden>
        </>
    );
};

const headerMb = css`
    ${mb(4)};
`;

const rankingHeader = css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const apla = css`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
`;

const rankingHeaderContent = (theme: Theme) => css`
    position: relative;
    z-index: 4;
    display: flex;
    gap: 75px;
    max-width: 1128px;
    justify-content: center;
    align-items: center;
    ${p(4.5, 1.5, 4, 1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(4.5, 1.5, 6, 1.5)};
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        ${p(10, 1.5, 4, 1.5)};
    }
`;

const headerFiltersMobile = css`
    ${p(3, 0, 6, 0)};
`;

const headline = css`
    font-weight: 400;
    ${mb(3)};
`;

const StyledButton = styled(Button)`
    width: 100%;

    @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
        width: auto;
    }
`;

const desktopPanel = css`
    flex: 1 0 453px;
`;
import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Apla} from "@pg-design/apla-module";
import {Button} from "@pg-design/button-module";
import {Col, Hidden} from "@pg-design/grid-module";
import {mb, p} from "@pg-design/helpers-css-strings";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {RankingMainViewFilterPanel} from "./RankingMainViewFilterPanel";

const headerXl = require("../../images/header_xl.png");
const headerLg = require("../../images/header_lg.png");
const headerMd = require("../../images/header_md.png");
const headerSm = require("../../images/header_sm.png");
const headerXs = require("../../images/header_xs.png");

interface IProps {
    onScrollToRankingCreationSteps: () => void;
}

export const RankingHeader = (props: IProps) => {
    return (
        <>
            <div css={rankingHeader}>
                <Apla
                    css={apla}
                    applyOn={
                        <Picture
                            sources={[
                                {minWidthPX: 0, src: headerXs, height: 512, width: 360},
                                {minWidthPX: 350, src: headerSm, height: 512, width: 600},
                                {minWidthPX: 600, src: headerMd, height: 512, width: 1366},
                                {minWidthPX: 1366, src: headerLg, height: 512, width: 1920},
                                {minWidthPX: 1920, src: headerXl, height: 512, width: 2560}
                            ]}
                            alt="header"
                            fit="top left"
                        />
                    }
                />
                <div css={rankingHeaderContent}>
                    <div>
                        <Text css={headline} color="#fff" fontFamily="secondary" variant="headline_1">
                            {concatWithBrandName("Ranking Inwestycji portalu")}
                        </Text>

                        <Text css={headerMb} color="#fff" variant="body_copy_0">
                            Po raz kolejny przygotowaliśmy zestawienie najpopularniejszych inwestycji w największych miastach w Polsce! Sprawdź, które
                            inwestycje odwiedzano najczęściej i które projekty deweloperskie przyciągnęły największą uwagę mieszkańców, którzy znaleźli
                            wymarzone M dzięki serwisowi {concatWithBrandName("")}!
                        </Text>

                        <StyledButton onClick={props.onScrollToRankingCreationSteps} variant="filled_primary" css={headerMb}>
                            Zobacz, jak powstał ranking
                        </StyledButton>
                    </div>
                    <Hidden on="mobile" css={desktopPanel}>
                        <RankingMainViewFilterPanel />
                    </Hidden>
                </div>
            </div>

            <Hidden on="desktop">
                <Col>
                    <div css={headerFiltersMobile}>
                        <RankingMainViewFilterPanel />
                    </div>
                </Col>
            </Hidden>
        </>
    );
};

const headerMb = css`
    ${mb(4)};
`;

const rankingHeader = css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const apla = css`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
`;

const rankingHeaderContent = (theme: Theme) => css`
    position: relative;
    z-index: 4;
    display: flex;
    gap: 75px;
    max-width: 1128px;
    justify-content: center;
    align-items: center;
    ${p(4.5, 1.5, 4, 1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(4.5, 1.5, 6, 1.5)};
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        ${p(10, 1.5, 4, 1.5)};
    }
`;

const headerFiltersMobile = css`
    ${p(3, 0, 6, 0)};
`;

const headline = css`
    font-weight: 400;
    ${mb(3)};
`;

const StyledButton = styled(Button)`
    width: 100%;

    @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
        width: auto;
    }
`;

const desktopPanel = css`
    flex: 1 0 453px;
`;
